import { DeployWebsite } from '@/feature/deploy/DeployWebsite'
import '@/feature/deploy/deploy.scss'

export default new DeployWebsite()
